import { render, staticRenderFns } from "./ConsultantForm.vue?vue&type=template&id=4afaca56&"
import script from "./ConsultantForm.vue?vue&type=script&lang=js&"
export * from "./ConsultantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports